import angular from 'angular';
import imageSlider from './ImageSlider.component';

export default angular.module('petroCloud.imageSlider', [])
  .component(imageSlider.name, imageSlider)
  .name;
